import React from "react";
const ProgressPopupDispatchContext = React.createContext();
const ProgressPopupDispatchProvider = ProgressPopupDispatchContext.Provider;

export { ProgressPopupDispatchContext, ProgressPopupDispatchProvider };
